export default __webpack_public_path__ + "static/media/downloadAsh.25520229.svg";